import {InjectionToken} from "@angular/core";

export let ACCOUNT_MANAGER_SERVICE = new InjectionToken('account-manager.service');
